<div class="caremoni-search-bar" [ngStyle]="searchParams.cssStyle">
    <div class="caremoni-input-search" *ngIf="searchParams.type === 1"
        [ngClass]="{'no-border': comboInputFocus, 'required': _required}">
        <input class="caremoni-input" type="text" placeholder="{{searchParams.placeholder}}" id={{inputSearchId}}
            [ngClass]="{
                'border-red-err': searchParams.borderRed
            }" [disabled]="_disable" readonly [ngModel]="searchValue" (keydown)="onKeyDowns($event)"
            (click)="onClickDropdown($event)" [maxlength]="searchParams.maxLength || null"
            (focus)="handleComboInputFocus($event)" (focusout)="handleComboInputFocusOut($event)" />
        <div class="caremoni-icon dropdown-icon" [ngClass]="dspSearchPanel? 'icon-rotate': ''"
            (click)="onClickDropdown($event)"></div>
    </div>

    <caremoni-dropdown-panel [_displayFilter]="_displayFilter" [_targetFilter]="_targetFilter"
        (_onHide)="onHidePanelSearch()" [_tempDataFilters]="searchParams.dataSource" [isFilter]="isFilter"
        [defaultValue]="searchValue" [displayText]="listFilterDspText" [cssStyle]="popupStyle"
        (_onFilterOutData)="filterOutData($event)" [_selectedData]="selectedData"
        [placeHolderFilter]="placeHolderFilter">
    </caremoni-dropdown-panel>
</div>